import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';

import { selectUserStartupId } from 'redux/selectors/auth';
import { StateType } from 'types';
import { addMember } from 'redux/actions/people';
import { selectNationalities } from 'redux/selectors/workspace';
import { getNationalities } from 'redux/actions/workspace';

const mapStateToProps = (state: StateType) => ({
  startupId: selectUserStartupId(state),
  nationalities: selectNationalities(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    addMember,
    getNationalities,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
